import ApplicationAdapter from 'volta/_pods/application/adapter';
import type ModelRegistry from "ember-data/types/registries/model";

export default class SimulationItemSettingTaskAdapter extends ApplicationAdapter {
  pathForType<K extends keyof ModelRegistry>(_modelName: K): string {
    return 'simulationItemSettings/tasks';
  }
}
